import numberUtils from 'app/shared/utils/numberUtils';

const { cleanPhoneNumber } = numberUtils;

const listingClaimUtils = {
    isEmailInContactMethods: (contactMethods, listingEmail) => contactMethods.emails
        .some(contact => (contact.value || contact) === listingEmail),
    isPhoneInContactMethods: (contactMethods, listingPhone) => contactMethods.phones
        .map(phoneNumber => cleanPhoneNumber(phoneNumber.value || phoneNumber))
        .includes(cleanPhoneNumber(listingPhone)),
    getContactType: contact => (isNaN(parseInt(contact.value, 10)) ? 'email' : 'phone'),
    getVerifiedContacts: combinedContactMethods => combinedContactMethods
        .some(contactMethod => contactMethod.isVerified),
    combineContactMethods: ({ emails, phones }) => [...emails, ...phones]
        .sort((a, b) => a.isVerified - b.isVerified),
    getConversionRate: ({ failed, succeeded, total }) => (((failed + succeeded) / total) * 100),
};

export default listingClaimUtils;
